// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-49293d30]:root{--tipografia-familia:\"Montserrat\",sans-serif;--tipografia-tamanio:16px;--tipografia-codigo:monospace}.modal-cabecera h1.modal-titulo[data-v-49293d30]{font-size:1.5rem;margin-top:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
